import React, { Component } from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import "./CreateNewFolder.scss";
import CloseIcon from "../../assets/icons/close.svg";
import ColorCodeDropdown from "../ColorCodeDropdown/ColorCodeDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import ArrowDown from "../../assets/icons/arrows/chevron-down.svg";
import dateFormat from "dateformat";
import { notify } from "../Notify/Notify";
import ShareWith from "./ShareWith/ShareWith";
import { Modal } from "react-bootstrap";

const folderColors = [
  { id: 1, value: "1", label: "Red", colorCode: "#ff9ead" },
  { id: 2, value: "2", label: "Orange", colorCode: "#ffa575" },
  { id: 3, value: "3", label: "Yellow", colorCode: "#ffda6b" },
  { id: 4, value: "4", label: "Green", colorCode: "#86e575" },
  { id: 5, value: "5", label: "Teal", colorCode: "#6de4d2" },
  { id: 6, value: "6", label: "Purple", colorCode: "#c09eff" },
  { id: 7, value: "7", label: "Primary", colorCode: "#cbd1fe" },
];

class CreateNewFolder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderTitle: "",
      parentFolder: !this.props.doNotShowRootOption
        ? 0
        : this.props.allRootFolders[0].id,
      folderColor: folderColors[6],
      shareUser: "",
      folderDescription: "",
      folderInstruction: "",
      childFoldersList: [],
      isFoldersListLoaded: true,
      showDropDown: false,
      accessUsers: [],
      filteredUsers: [],
      folderAccess: [
        { id: 31, access: "Owner" },
        { id: 32, access: "Collaborator" },
        { id: 33, access: "Viewer" },
        { id: 34, access: "Temporary User" },
      ],
    };
  }

  locationDropdown = React.forwardRef(({ onClick }, ref) => (
    <button
      className="btn-dropdown btn-location-dropdown mr-2"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className="text-label">
        {" "}
        {this.state.parentFolder === 0
          ? "(Root Level)"
          : [...this.props.allRootFolders].filter(
              (obj) => obj.id === this.state.parentFolder
            )[0]
          ? [...this.props.allRootFolders].filter(
              (obj) => obj.id === this.state.parentFolder
            )[0].title
          : ""}
      </div>
      <img
        className="ml-1 mr-0"
        width="20"
        height="20"
        src={ArrowDown}
        alt="arrowDown"
      />
    </button>
  ));

  getTotalDays = (date) => {
    const dateDay = dateFormat(date, "dd");
    const dateMonth = dateFormat(date, "mm");
    const dateYear = dateFormat(date, "yyyy");

    let first = new Date();
    let second = new Date(
      parseInt(dateYear),
      parseInt(dateMonth) - 1,
      parseInt(dateDay)
    );

    const totalDays = Math.round((second - first) / (1000 * 60 * 60 * 24));
    return totalDays;
  };

  setAccessUsers = (usersArr) => {
    const filteredArr = usersArr.reduce((acc, current) => {
      const x = acc.find((item) => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    this.setState({ accessUsers: filteredArr });
  };

  setFilteredUsers = (filterUsers) => {
    this.setState({ filteredUsers: filterUsers });
  };

  submitCreateFolder = (e) => {
    e.preventDefault();
    let userIds_data = [];
    this.state.accessUsers.map((accessUser, index) => {
      return index !== 0 && accessUser.access !== "Temporary User"
        ? userIds_data.push({
            id: accessUser.id,
            role: accessUser.access,
          })
        : accessUser.access === "Temporary User"
        ? userIds_data.push({
            id: accessUser.id,
            role: "Temporary User",
            days: this.getTotalDays(accessUser.temporaryDate),
          })
        : null;
    });

    const variables = {
      title: this.state.folderTitle.trim(),
      description: this.state.folderDescription.trim(),
      instruction: this.state.folderInstruction.trim(),
      isRoot: this.state.parentFolder === 0,
      color: this.state.folderColor.colorCode,
      userIds: JSON.stringify(userIds_data),
    };
    let mutation;
    if (!variables.isRoot) {
      variables["parentFolderId"] = this.state.parentFolder;
      mutation = `
      mutation CreateFolder(
        $title: String!
        $description: String!
        $instruction: String!
        $isRoot: Boolean!
        $color: String!
        $parentFolderId: UUID!
        $userIds: String!
      ) {
        createFolder(
          title: $title
          description: $description
          instruction: $instruction
          isRoot: $isRoot
          color: $color
          userIds: $userIds
          parentFolderId: $parentFolderId
        ) {
          folder {
            id
            title
            isRoot
            color {
              id
              name
            }
            description
            instruction
            createdBy {
              profile{
                image
                role {
                  id
                  name
                }
              }
              id
              username
              firstName
              lastName
              email
            }
            modifiedTs
            parentFolder {
              id
              title
            }
            sharedFolder {
              id
              user {
                id
                email
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              userRole {
                id
                name
              }
            }
            pinnedFolder {
              user {
                id
              }
              folder {
                id
                title
              }
            }
          }
        }
      }`;
    } else {
      mutation = `mutation CreateFolder(
        $title: String!
        $description: String!
        $instruction: String!
        $isRoot: Boolean!
        $color: String!
        $userIds: String!
      ) {
        createFolder(
          title: $title
          description: $description
          instruction: $instruction
          isRoot: $isRoot
          color: $color
          userIds: $userIds
        ) {
          folder {
            id
            title
            isRoot
            color {
              id
              name
            }
            description
            instruction
            createdBy {
              id
              firstName
              lastName
              email
              username
              profile {
                image
                role {
                  id
                  name
                }
              }
            }
            sharedFolder {
              id
              user {
                id
                email
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              userRole {
                id
                name
              }
            }
            pinnedFolder {
              user {
                id
              }
              folder {
                id
                title
              }
            }
            modifiedTs
          }
        }
      }`;
    }
    apolloClient
      .mutate({
        variables: variables,
        mutation: gql`
          ${mutation}
        `,
      })
      .then((result) => {
        this.props.handleFolderModal();
        this.props.onNewFolderAdded({
          ...result.data,
          parentFolderId: !variables.isRoot ? this.state.parentFolder : null,
        });

        const childFoldersList = [...this.state.childFoldersList];
        childFoldersList.push(
          this.state.folderTitle.trim().toLocaleLowerCase()
        );
        this.setState({
          folderTitle: "",
          folderColor: folderColors[6],
          parentFolder: !this.props.doNotShowRootOption
            ? 0
            : this.props.allRootFolders[0].id,
          shareUser: "",
          folderDescription: "",
          folderInstruction: "",
          childFoldersList: childFoldersList,
          showDropDown: false,
          showDatePiker: false,
          accessUsers: [this.state.accessUsers[0]],
          filteredUsers: [],
        });
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message.includes("Guest user")
          ? "Please provide only Temporary User access to a Guest user!"
          : e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  updatedFolder = () => {
    const variables = {
      folderId: this.props.updateFolder.id,
      title: this.state.folderTitle,
      description: this.state.folderDescription || "",
      instruction: this.state.folderInstruction || "",
      color: this.state.folderColor.colorCode,
    };
    apolloClient
      .mutate({
        variables: variables,
        mutation: gql`
          mutation EditFolder(
            $folderId: UUID!
            $title: String
            $description: String
            $instruction: String
            $color: String
          ) {
            editFolder(
              folderId: $folderId
              title: $title
              description: $description
              instruction: $instruction
              color: $color
            ) {
              success
            }
          }
        `,
      })
      .then((result) => {
        this.props.handleFolderModal();
        const {
          createdBy,
          sharedFolder,
          parentFolder,
          pinnedFolder,
          modifiedTs,
        } = this.props.updateFolder;
        const editFolder = {
          id: this.props.updateFolder.id,
          title: this.state.folderTitle,
          color: this.state.folderColor,
          description: this.state.folderDescription,
          instruction: this.state.folderInstruction,
          createdBy,
          sharedFolder,
          isArchive: false,
          isRoot: parentFolder ? false : true,
          parentFolder,
          pinnedFolder,
          modifiedTs,
        };
        this.props.onFolderUpdated({
          editFolder: editFolder,
          parentFolderId: this.props.updateFolder.parentFolder
            ? this.props.updateFolder.parentFolder.id
            : null,
        });

        const title = "Success";
        const detail = "Folder updated successfully!";
        const type = "success";
        notify(title, detail, type);
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  hasValidValue = () => {
    if (this.props.editFolder) {
      const childs = [...this.state.childFoldersList];
      const updatedChilds = childs.filter(
        (child) => child !== this.props.updateFolder.title
      );
      const Title = this.state.folderTitle.toLowerCase();
      const isValid =
        this.state.isFoldersListLoaded ||
        !updatedChilds.includes(this.state.folderTitle.trim().toLowerCase()) ||
        this.state.folderColor;
      return (
        isValid &&
        !Title.includes("personal folder") &&
        this.state.folderTitle.trim().length > 0
      );
    } else {
      const Title = this.state.folderTitle.toLowerCase();
      return (
        this.state.folderTitle.trim().length > 0 &&
        !Title.includes("personal folder") &&
        this.state.isFoldersListLoaded &&
        !this.state.childFoldersList.includes(
          this.state.folderTitle.trim().toLowerCase()
        ) &&
        this.state.folderColor
      );
    }
  };

  getAllChildFolders = () => {
    const folder = this.props.folder ? this.props.folder[0] : undefined;
    const variables = folder
      ? {
          parentFolderId: folder.parentFolder
            ? folder.parentFolder.id
            : folder.id,
        }
      : {
          parentFolderId: this.state.parentFolder,
        };

    if (this.state.isFoldersListLoaded)
      this.setState({ isFoldersListLoaded: false });

    apolloClient
      .query({
        query: gql`
          query subFolder($parentFolderId: UUID!) {
            subFolders(parentFolderId: $parentFolderId) {
              folderId: id
              title
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let childFoldersList = [];
        result.data.subFolders.map((item) =>
          childFoldersList.push(item.title.toLowerCase())
        );
        this.setState({ childFoldersList, isFoldersListLoaded: true });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  loadRootChildren = () => {
    if (this.state.isFoldersListLoaded)
      this.setState({ isFoldersListLoaded: false });

    apolloClient
      .query({
        query: gql`
          query {
            foldersForUser {
              id
              title
            }
          }
        `,
      })
      .then((result) => {
        let childFoldersList = [];
        result.data.foldersForUser.map((item) =>
          childFoldersList.push(item.title.toLowerCase())
        );
        this.setState({ childFoldersList, isFoldersListLoaded: true });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  cancelHandler = () => {
    this.props.handleFolderModal();
    if (this.props.editFolder) {
      const folder = this.props.updateFolder;
      this.setState({
        folderTitle: folder.title,
        folderColor: folderColors[parseInt(folder.color.id) - 1],
        folderDescription: folder.description,
        folderInstruction: folder.instruction,
        accessUsers: [],
      });
    } else {
      this.setState({
        folderTitle: "",
        folderColor: folderColors[6],
        folderDescription: "",
        folderInstruction: "",
        accessUsers: [],
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutsideOfUserSearch);
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateFolder) {
      const length = Object.entries(this.props.updateFolder).length;
      const check = this.props.updateFolder.id !== prevProps.updateFolder.id;
      if (length > 0 && check) {
        const folder = this.props.updateFolder;
        if (folder.parentFolder) {
          this.getAllChildFolders();
        } else {
          this.loadRootChildren();
        }
        this.setState({
          folderTitle: folder.title,
          folderColor: folderColors[parseInt(folder.color.id) - 1],
          folderDescription: folder.description,
          folderInstruction: folder.instruction,
        });
      } else if (length === 0 && check) {
        this.getAllChildFolders();
        this.setState({
          folderTitle: "",
          folderColor: folderColors[6],
          folderDescription: "",
          folderInstruction: "",
        });
      }
    }
  }

  render() {
    let isDuplicateFolderName = false;
    let isPersonalFolder = false;
    let isDisabled = false;
    const childs = [...this.state.childFoldersList];
    if (this.props.editFolder) {
      const updatedChilds = childs.filter(
        (child) =>
          child.toLowerCase() !== this.props.updateFolder.title.toLowerCase()
      );
      if (
        this.state.isFoldersListLoaded &&
        updatedChilds.includes(this.state.folderTitle.trim().toLowerCase())
      ) {
        isDuplicateFolderName = true;
      }

      // personal folder validation
      if (
        !this.props.updateFolder.title.toLowerCase().includes("personal folder")
      ) {
        const Title = this.state.folderTitle.toLowerCase();
        if (Title.length > 0 && Title.includes("personal folder")) {
          isPersonalFolder = true;
        }
        isDisabled = false;
      } else {
        isDisabled = true;
      }
    } else {
      if (
        this.state.isFoldersListLoaded &&
        this.state.childFoldersList.includes(
          this.state.folderTitle.trim().toLowerCase()
        )
      ) {
        isDuplicateFolderName = true;
      }

      // personal folder validation
      const Title = this.state.folderTitle.toLowerCase();
      if (Title.length > 0 && Title.includes("personal folder")) {
        isPersonalFolder = true;
      }
    }

    return (
      <Modal
        size="lg"
        dialogClassName={`${
          !this.props.editFolder ? "default-dialog" : "default-dialog-edit"
        }`}
        show={this.props.showFolderModal}
        onHide={this.props.handleFolderModal}
        centered
      >
        <Modal.Header>
          {!this.props.editFolder ? (
            <h4 className="modal-title">{this.props.createSubFolder ? "Create New Sub Folder" : "Create New Folder"}</h4>
          ) : (
            <h4 className="modal-title">Edit Folder</h4>
          )}
          <img
            className="close"
            src={CloseIcon}
            alt="closeIcon"
            onClick={this.props.handleFolderModal}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row d-flex justify-content-center">
              <div
                className={`${
                  !this.props.editFolder ? "col-md-5" : "col-md-12"
                }`}
              >
                <div>
                  <label>Folder Name*</label>
                  <input
                    type="text"
                    placeholder="Enter folder name"
                    maxLength="50"
                    onChange={(e) => {
                      this.setState({ folderTitle: e.target.value });
                    }}
                    value={this.state.folderTitle}
                    disabled={isDisabled}
                    className={this.props.editFolder ? "handle-width" : ""}
                  />
                  {isDuplicateFolderName ? (
                    <span className="error-message">
                      Folder name is already existing. Please rename the folder
                      name.
                    </span>
                  ) : isPersonalFolder ? (
                    <span className="error-message">
                      Please avoid using keyword personal folder in the folder
                      name
                    </span>
                  ) : null}
                </div>
                {!this.props.editFolder ? (
                  <div className="mt-8">
                    <label>Folder Location*</label>
                    <Dropdown alignRight className="ml-auto location-dropdown">
                      <Dropdown.Toggle
                        as={this.locationDropdown}
                      ></Dropdown.Toggle>
                      <Dropdown.Menu>
                        {!this.props.doNotShowRootOption ? (
                          <Dropdown.Item
                            as="a"
                            key="0"
                            value={0}
                            className={
                              this.state.parentFolder === 0
                                ? "selected text-label"
                                : "text-label"
                            }
                            onClick={(e) => {
                              this.setState(
                                {
                                  parentFolder: 0,
                                },
                                this.loadRootChildren
                              );
                            }}
                          >
                            (Root Level)
                          </Dropdown.Item>
                        ) : null}

                        {this.props.allRootFolders.map((flKey) => (
                          <Dropdown.Item
                            as="a"
                            key={flKey.id}
                            value={flKey.id}
                            className={
                              this.state.parentFolder === flKey.id
                                ? "selected text-label"
                                : "text-label"
                            }
                            onClick={(e) => {
                              this.setState(
                                {
                                  parentFolder: flKey.id,
                                },
                                this.getAllChildFolders
                              );
                            }}
                          >
                            {flKey.title}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                ) : null}
                <div className="mt-8">
                  <label>Color Code For Folder*</label>
                  <ColorCodeDropdown
                    editFolder={this.props.editFolder}
                    colorCodes={folderColors}
                    folderColor={this.state.folderColor}
                    handleColorCodeClick={(colorObj) => {
                      this.setState({ folderColor: colorObj });
                    }}
                  />
                </div>
                <div className="mt-8">
                  <label>Folder Description</label>
                  <textarea
                    placeholder="Pro Tip: inserting a folder description is a great way to promote process standardization."
                    maxLength="300"
                    onChange={(e) => {
                      this.setState({ folderDescription: e.target.value });
                    }}
                    value={this.state.folderDescription}
                    className={this.props.editFolder ? "handle-width" : ""}

                    // required
                  />
                </div>
                {
                  !this.state.folderTitle.toLowerCase().includes("personal folder") ?
                  (
                    <div className="mt-8">
                      <label>Folder Instructions</label>
                      <textarea
                        placeholder="Pro Tip: Inserting a folder instructions is a great way to promote proper naming conventions"
                        maxLength="300"
                        onChange={(e) => {
                          this.setState({ folderInstruction: e.target.value });
                        }}
                        value={this.state.folderInstruction}
                        className={this.props.editFolder ? "handle-width" : ""}
                      />
                    </div>
                  ) : null
                }
              </div>
              {!this.props.editFolder ? (
                <ShareWith
                  colClass="col-md-7"
                  defaultRole="Owner"
                  folderAccess={this.state.folderAccess}
                  accessUsers={this.state.accessUsers}
                  filteredUsers={this.state.filteredUsers}
                  setAccessUsers={this.setAccessUsers}
                  setFilteredUsers={this.setFilteredUsers}
                  currentUserInfo={this.props.currentUserInfo}
                />
              ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn-secondary"
            data-dismiss="modal"
            onClick={this.cancelHandler}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="btn-primary"
            onClick={
              !this.props.editFolder
                ? this.submitCreateFolder
                : this.updatedFolder
            }
            disabled={!this.hasValidValue()}
          >
            {!this.props.editFolder ? <>Create</> : <>Update</>}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CreateNewFolder;
